import { PHONE_NUMBER } from "../../../constants/global";
import { hasXSSCharacters, isEmail, isFullNameValid } from "../../../helpers/Utils";
import { GiftCardSendTypeEnum } from "../../enums/GiftCardSendTypeEnum";

export interface IChooseRecipientsStepModel {
    sendIndividually: boolean;
    sendBy: GiftCardSendTypeEnum;
    recipients: Array<IRecipientDetails>;
}

export class ChooseRecipientsStepModel implements IChooseRecipientsStepModel {
    sendIndividually: boolean;
    sendBy: GiftCardSendTypeEnum;
    recipients: Array<IRecipientDetails>;
    
    constructor() {
        this.sendIndividually = true;
        this.sendBy = GiftCardSendTypeEnum.BY_EMAIL;
        this.recipients = new Array<RecipientDetailsModel>();
    }

    static isValid(model: IChooseRecipientsStepModel): boolean {
        if (!model.recipients || model.recipients.length == 0) {
            return false;
        }

        let isValid = true;

        model.recipients.forEach(r => {
            if (!r.fullName || !isFullNameValid(r.fullName.trim())) {
                isValid = false;
            }

            if (model.sendBy === GiftCardSendTypeEnum.BY_EMAIL) {
                if (!isEmail(r.email)) {
                    isValid = false;
                }

                if (r.phone && hasXSSCharacters(r.phone)) {
                    isValid = false;
                }
            } else if (model.sendBy === GiftCardSendTypeEnum.BY_SMS) {
                const ieRegex = PHONE_NUMBER.VALIDATIONS.REGEX.IE;
                const ukRegex = PHONE_NUMBER.VALIDATIONS.REGEX.GB;

                if (!ieRegex.test(r.phone) && !ukRegex.test(r.phone)) {
                    isValid = false;
                }

                if (r.email && !isEmail(r.email)) {
                    isValid = false;
                }
            }
        });

        return isValid;
    }
}

export interface IRecipientDetails {
    fullName: string;
    email: string;
    phone: string;
}

export class RecipientDetailsModel implements IRecipientDetails {
    fullName: string;
    email: string;
    phone: string;

    constructor() {
        this.fullName = '';
        this.email = '';
        this.phone = '';
    }
}